import { SEND_EVENT } from 'botframework-webchat-core/lib/actions/sendEvent';
import { SEND_MESSAGE } from 'botframework-webchat-core/lib/actions/sendMessage';
const answerFeedbackEventName = 'answerFeedback';
const ERROR_CODE_REGEXP = /(rfm[\s-]?\d{2,3})|(\b[sa][\s-]?\d{3})/gi;
const DIGITS_REGEXP = /(.{2})(\d+)/g;
const PLACEHOLDER = '_rfm_placeholder_';
const MASK_CHAR = '*';
function findMatches(regexp, text, textMatchIndex = 0) {
    const matchIndices = [];
    let match;
    do {
        match = regexp.exec(text);
        if (match) {
            const index = textMatchIndex > 0
                ? match.index +
                    match.slice(1, textMatchIndex).reduce((total, match) => total + match.length, 0)
                : match.index;
            matchIndices.push({ index, text: match[textMatchIndex] });
        }
    } while (match);
    return matchIndices;
}
function maskMatchedText(match, text, maskString) {
    return (text.substring(0, match.index) +
        maskString.padEnd(match.text.length, maskString) +
        text.substring(match.index + match.text.length));
}
function replacePlaceholder(match, text, placeholder) {
    return text.substring(0, match.index) + match.text + text.substring(match.index + placeholder.length);
}
function mask(text) {
    const rfmMatches = findMatches(ERROR_CODE_REGEXP, text);
    const rfmMasked = text.replace(ERROR_CODE_REGEXP, PLACEHOLDER);
    const piiMatches = findMatches(DIGITS_REGEXP, rfmMasked, 2);
    let maskedString = rfmMasked;
    piiMatches.forEach((match) => {
        maskedString = maskMatchedText(match, maskedString, MASK_CHAR);
    });
    rfmMatches.forEach((m) => {
        maskedString = replacePlaceholder(m, maskedString, PLACEHOLDER);
    });
    return maskedString;
}
const myGovPIIMaskingMiddleware = () => (next) => (action) => {
    if (action.type === SEND_MESSAGE) {
        action.payload.text = mask(action.payload.text);
    }
    else if (action.type === SEND_EVENT && action.payload.name === answerFeedbackEventName) {
        const payload = action.payload.value;
        payload.feedback.forEach((feedback) => {
            feedback.text = mask(feedback.text);
        });
    }
    return next(action);
};
export { myGovPIIMaskingMiddleware };
//# sourceMappingURL=myGovPIIMaskingMiddleware.js.map